<template>
  <component :is="tag" ref="root" :style="getStyles" class="def-slide">
    <slot />
  </component>
</template>
<script>
export default {
  name: 'DefSlide',
  props: {
    active: Boolean,
    x: Boolean,
    y: Boolean,
    duration: {
      type: String,
      default: '.2s',
    },
    tag: {
      type: String,
      default: 'div',
    },
  },
  data() {
    return {
      width: null,
      height: null,
    };
  },
  computed: {
    getStyles() {
      /**
       * time transition
       * */

      const transition = `transition: ${this.duration} linear width, ${this.duration} linear height;`;

      if (this.x === true) {
        /**
         * animation with width
         */
        if (this.active && this.width !== null) {
          return `width: ${this.width}px; ${transition}`;
        }
        if (this.width !== null) {
          return `width: 0px; ${transition}`;
        }
      } else if (this.y === true) {
        /**
         * animation width height
         * * */
        if (this.active && this.height !== null) {
          return `height: ${this.height}px; ${transition}`;
        }
        if (this.height !== null) {
          return `height: 0px; ${transition}`;
        }
      }
    },
  },
  mounted() {
    /**
     * init start data
     */

    // const { height, width } = this.$el.getBoundingClientRect();
    //
    // this.width = this.$el.scrollWidth;
    // this.height = height;

    requestAnimationFrame(() => {
      this.width = this.$el.scrollWidth;
      this.height = this.$el.scrollHeight;
    });
  },
};
</script>

<style lang="scss" scoped>
.def-slide {
  overflow: hidden;
}
</style>
